/**
 * Axios Request Wrapper
 * ---------------------
 *
 * @author  Sheharyar Naseer (@sheharyarn)
 * @license MIT
 *
 */

import axios from 'axios'

/**
 * Create an Axios Client with defaults
 */

const client = axios.create({
})

/**
 * Request Wrapper with default success/error actions
 */
const request = function (options) {
  const token = options.token || localStorage.getItem('token') || ''
  options.headers = {
    ...options.headers,
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }

  const onSuccess = function (response) {
    return response
  }

  const onError = function (error) {
    console.error('Request Failed:', error.config)

    if (error.response) {
      const errorInfo = {
        status: error.response.status, // Include the HTTP status code
        message: error.response.data.message || 'An error occurred', // Generic message if specific one is unavailable
        data: error.response.data // Include the response data (optional, might contain useful error details)
      }

      return Promise.reject(errorInfo) // Reject with structured error
    } else {
      const errorInfo = {
        message: error.message
      }
      return Promise.reject(errorInfo)
    }
  }

  return client(options).then(onSuccess).catch(onError)
}

export default request
